module.exports = __webpack_public_path__ + "static/media/dark-bg.3a407572.svg";